import React from "react"

import style from "./AvailableCoupon.module.scss"

export default function AvailableCoupon(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------
  const {
    code,
    discount_value,
    coupon_claims_count,
    redeem_max_times,
    lower_limit_price_cents,
    no_weekend,
    onClick,
    start_date,
    end_date,
    isSelected,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderMinimumOrder() {
    const amount = lower_limit_price_cents
    if (!amount || amount <= 0) return null

    return (
      <p className="fr-p4 fr-white fr-margin-bottom-xsmall">
        {I18n.t("pages.orders.new.available_coupon.minimum_value", {
          amount: amount / 100.0,
        })}
      </p>
    )
  }

  function renderNoWeekend() {
    if (!no_weekend) return null

    return (
      <p className="fr-p4 fr-white fr-margin-bottom-xsmall">
        {I18n.t("pages.orders.new.available_coupon.no_weekend")}
      </p>
    )
  }

  function renderValidityDates() {
    if (!end_date) return null

    let endDate = new Date(end_date)

    if (!endDate) return null

    return (
      <p className="fr-p4 fr-white fr-margin-bottom-xsmall">
        {I18n.t("pages.orders.new.available_coupon.validity", {
          date: endDate.toLocaleString(I18n.locale, {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
          }),
        })}
      </p>
    )
  }

  function renderRedeemTimes() {
    if (
      redeem_max_times === null ||
      coupon_claims_count == null ||
      redeem_max_times === undefined ||
      coupon_claims_count == undefined
    ) {
      return null
    }

    return (
      <p className="fr-p4 fr-white fr-margin-bottom-xsmall">
        {I18n.t("pages.orders.new.available_coupon.redeem_times", {
          count: redeem_max_times - coupon_claims_count,
        })}
      </p>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------
  return (
    <div onClick={onClick} className={style.box}>
      {isSelected && <div className={style.selected}>
      <i className={`fas fa-check fr-white`} />
      </div> }
      <p className="fr-p4 fr-white">
        {I18n.t("pages.orders.new.available_coupon.value_title")}
      </p>
      <p className="fr-h4 fr-normal fr-white">
        {Intl.NumberFormat("IT-it", { minimumFractionDigits: 2 }).format(
          discount_value / 100
        )}{" "}
        <span className={`${style.couponCurrency} fr-p4`}>EUR</span>
      </p>
      <p className="fr-p1 fr-normal fr-white">{code}</p>
      <div>
        {renderMinimumOrder()}
        {renderNoWeekend()}
        {renderValidityDates()}
        {renderRedeemTimes()}
      </div>
    </div>
  )
}
